module.exports = __webpack_public_path__ + "img/home-hot-lot-logo.png";